import { getRememberedLocale } from "@/lib/authMessages";

export const copy = {
  en: {
    title: "Your session is about to expire",
    body: "You will be signed out in about 5 minutes because there has been no activity. Any unfinished interview will not be retained.",
    continue: "Continue session",
    signedOut: "You were signed out after 60 minutes of inactivity.",
  },
  "fr-CA": {
    title: "Votre session est sur le point d’expirer",
    body: "Vous serez déconnecté dans environ 5 minutes en raison d’une période d’inactivité. Toute entrevue inachevée ne sera pas conservée.",
    continue: "Continuer la session",
    signedOut: "Vous avez été déconnecté après 60 minutes d’inactivité.",
  },
  "es-419": {
    title: "Su sesión está por vencer",
    body: "Se cerrará su sesión en aproximadamente 5 minutos porque no ha habido actividad. No se conservará ninguna entrevista sin terminar.",
    continue: "Continuar sesión",
    signedOut: "Su sesión se cerró después de 60 minutos de inactividad.",
  },
  "pt-BR": {
    title: "Sua sessão está prestes a expirar",
    body: "Você será desconectado em aproximadamente 5 minutos porque não houve atividade. Qualquer entrevista não concluída não será mantida.",
    continue: "Continuar sessão",
    signedOut: "Você foi desconectado após 60 minutos de inatividade.",
  },
};

export function getSessionTimeoutCopy(locale = getRememberedLocale()) {
  return copy[locale] || copy.en;
}
